var _dec, _class, _descriptor, _descriptor2, _cache, _orderIndex;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import rpc from '@banking/api/utils/rpc';
import { Action, GetMessageUnitsRequest, MessageserviceService, TrackEngagementRequest } from '@square/dashboard-protos/models/squareup/messageservice/service';
export const BANKING_HOME_PAGE_PLACEMENT_ID = '7f36d5b5-13c8-4560-a322-d8d201c54b1f';
export const BANKING_BALANCE_OVERVIEW_PAGE_PLACEMENT_ID = '643cf245-b7a0-40e1-ae3d-fd9d06c82467';

// GetMessageUnits defaults to 1, so this limit is necessary to fetch messages.
export const BANKING_MESSAGES_LIMIT = 25;
function index([map, set], unit) {
  // TODO(steckel): Consider asserting value we're indexing exists
  map.set(unit.requestToken, unit);
  set.add(unit.requestToken);
  return [map, set];
}
let MessageService = (_dec = computed('capitalEngineContext.headers'), _class = (_cache = /*#__PURE__*/new WeakMap(), _orderIndex = /*#__PURE__*/new WeakMap(), class MessageService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    // TODO(steckel): Map and Set could be combined with an OrderedMap
    _classPrivateFieldInitSpec(this, _cache, {
      writable: true,
      value: new Map()
    });
    _classPrivateFieldInitSpec(this, _orderIndex, {
      writable: true,
      value: new Map()
    });
  }
  // TODO(steckel): Extract headers into its own service and inject here.
  get client() {
    return MessageserviceService.create(rpc(
    // TODO(steckel): Find a way to test this. This worked in development
    // but broke in staging (when apiHostUrl was passed).
    // NOTE(steckel): avoid passing in apiHostUrl from '@banking/api/utils/rpc'
    // as it will change the RPC endpoint hostname to https://api.* rather
    // than keep it on the same domain and therefore cause CORS issues.
    (_, derivedUrl) => derivedUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  async getMessageUnits(placementId) {
    try {
      if (_classPrivateFieldGet(this, _cache)?.get(placementId) == null) {
        const request = GetMessageUnitsRequest.create({
          placementId,
          limit: BANKING_MESSAGES_LIMIT
        });
        const {
          messageUnits
        } = await this.client.getMessageUnits(request);
        const [cache, orderIndex] = messageUnits.reduce(index, [new Map(), new Set()]);
        _classPrivateFieldGet(this, _cache).set(placementId, cache);
        _classPrivateFieldGet(this, _orderIndex).set(placementId, orderIndex);
      }
      const cachedMessages = _classPrivateFieldGet(this, _cache)?.get(placementId);

      // TODO(steckel): consider assert over !
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return [...cachedMessages.values()];
    } catch (e) {
      this.sentry.captureException(e);
      throw e;
    }
  }
  async trackEngagement(placementId, requestToken, action) {
    try {
      if (!_classPrivateFieldGet(this, _cache).get(placementId)?.has(requestToken)) {
        throw new Error('Cannot trackEngagement for MessageUnits not already cached by MessageService.');
      }
      const request = TrackEngagementRequest.create({
        requestToken,
        action
      });
      await this.client.trackEngagement(request);
      if (action === Action.DISMISS) {
        _classPrivateFieldGet(this, _cache).get(placementId)?.delete(requestToken);
        _classPrivateFieldGet(this, _orderIndex).get(placementId)?.delete(requestToken);
      }
    } catch (e) {
      this.sentry.captureException(e);
      throw e;
    }
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _class);
export { MessageService as default };